import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/Login'
import Intro from '@/components/Intro'
import Cadastro from '@/components/Cadastro'
import Dashboard from '@/components/Dashboard'
import Conta from '@/components/Conta'
import AlterarSenha from '@/components/AlterarSenha'
import RecuperarSenha from '@/components/RecuperarSenha'
import Usuarios from '@/components/Usuarios'
import Relatorios from '@/components/Relatorios'
import Posts from '@/components/Posts'
import Agendamentos from '@/components/Agendamentos'
import Agenda from '@/components/Agenda'
import Sintomas from '@/components/Sintomas'
import Mural from '@/components/Mural'
import Configuracoes from '@/components/Configuracoes'
import Campanhas from '@/components/Campanhas'
import Pacientes from '@/components/Pacientes'
import Receitas from '@/components/Receitas'
import Profissionais from '@/components/Profissionais'
import ConfirmarAgendamento from '@/components/ConfirmarAgendamento'
import GerenciarUsuarios from '@/components/GerenciarUsuarios'
import GerenciarReceitas from '@/components/GerenciarReceitas'
import GerenciarPosts from '@/components/GerenciarPosts'
import Arquivos from '@/components/Arquivos'
import Paciente from '@/components/Paciente'
import Convenios from '@/components/Convenios'
import Teleconsulta from '@/components/Teleconsulta'
import { isMobile } from 'mobile-device-detect';
var loggedRoute 	= "Dashboard";
var notLoggedRoute 	= "Login";

// if (!window.localStorage.getItem("_intro")) {
// 	notLoggedRoute 		= "Introducao";
// }

Vue.use(Router)

const checkLogin 	= (to, from, next) => {
    var self    	= this;

    console.log("checkLogin()", to, from, next)

    if (!window.localStorage.getItem("_usuario")) {
        if (to.meta.auth == false || typeof to.meta.auth == "undefined") {
	   		next();
	   		return;             	
        }
        if (to.meta.auth == true) {
        }        
    } else {
        var usuario = null;
        try {
            usuario = JSON.parse(window.localStorage.getItem("_usuario"));
            window.__usuario = usuario;
            if (usuario.cod) {
		        if (to.meta.auth == false) {
				 	_this.push({ 
					   	name: loggedRoute,
					   	params: {
					   		"reload": 1 	
					   	}
				 	}).catch(()=>{});			
				 	// console.log("Esta logado e a pagina nao permite", _this);
				 	if (_this.currentRoute.params.reload == 1) {
				 		console.log("Faz reload")
				 		window.location.reload();   		
			   		}
			   		return;             	
		        }

		        if (to.meta.auth && to.meta.level) {
		        	if (to.meta.level.indexOf(usuario.tipo) == -1) {
					 	_this.push({ 
						   	name: loggedRoute
					 	}).catch(()=>{});					        		
		        	}
		        }
	            
       
		   		next();
		   		return;            
            } else {
            	// console.log("ELSE")
            	// if ()
            }

        } catch(err) {
            // return false;
        }
    }
    
 	_this.push({ 
	   	name: notLoggedRoute
 	}).catch(()=>{});
};

var _this = new Router({
	// mode: 'history',
  	routes: [
	    {
	      	path: '/',
	      	name: 'Dashboard',
	      	meta: {
	      		title: 		"Início",
	      		// auth: 		true,
		      	// level: 		["contratante", "admin", "profissional", "marketing"],
	      	},
	      	component: Dashboard,
	      	beforeEnter: checkLogin,
	    },
	    {
	      	path: '/login/',
	      	name: 'Login',
	      	meta: {
	      		title: 		"Login",
	      		auth: 		false,
	      	},
	      	component: Login,
	      	beforeEnter: checkLogin,
	    }, 
	    {
	      	path: '/intro/',
	      	name: 'Introducao',
	      	meta: {
	      		title: 		"Intro",
	      		// auth: 		false,
	      	},
	      	component: Intro,
	      	beforeEnter: checkLogin,
	    }, 	     
	    {
	      	path: '/cadastro/',
	      	name: 'Cadastro',
	      	meta: {
	      		title: 		"Cadastro",
	      		auth: 		false,
	      	},
	      	component: Cadastro,
	      	beforeEnter: checkLogin,
	    },
	    {
	      	path: '/recuperar-senha/',
	      	name: 'RecuperarSenha',
	      	meta: {
	      		title: 		"Recuperar senha",
	      		auth: 		false,
	      	},
	      	component: RecuperarSenha,
	      	beforeEnter: checkLogin,
	    },	  
	    {
	      	path: '/confirmar-agendamento/',
	      	name: 'ConfirmarAgendamento',
	      	meta: {
	      		title: 		"Confirmar agendamento",
	      	},
	      	component: ConfirmarAgendamento,
	      	beforeEnter: checkLogin,
	    },	  	        	      
	    {
	      	path: '/dicas/',
	      	name: 'Posts',
	      	meta: {
	      		title: 		"Dicas semanais",
		      	// auth: 		true,
		      	backButton: true,
		      	// level: 		["admin", "profissional", "contratante", "marketing"],
	      	},
	      	component: Posts,
	      	beforeEnter: checkLogin,
	    },	
	    {
	      	path: '/dicas/cadastro/',
	      	name: 'CadastrarPosts',
	      	meta: {
	      		title: 		"Cadastrar dica",
		      	auth: 		true,
		      	backButton: true,
		      	level: 		["marketing", "admin"],
		      	options: {
		      		
		      	}
	      	},
	      	component: GerenciarPosts,
	      	beforeEnter: checkLogin,
	    },	
	    {
	      	path: '/dicas/editar/',
	      	name: 'EditarPosts',
	      	meta: {
	      		title: 		"Editar dica",
		      	auth: 		true,
		      	backButton: true,
		      	level: 		["marketing", "admin"],
		      	options: {
		      		
		      	}
	      	},
	      	component: GerenciarPosts,
	      	beforeEnter: checkLogin,
	    },		    	    
	    {
	      	path: '/convenios/',
	      	name: 'Convenios',
	      	meta: {
	      		title: 		"Convênios",
		      	// auth: 		true,
		      	backButton: true,
		      	// level: 		["admin", "profissional", "contratante"],
	      	},
	      	component: Convenios,
	      	beforeEnter: checkLogin,
	    },		     
	    {
	      	path: '/agendamentos/',
	      	name: 'Agendamentos',
	      	meta: {
	      		title: 		"Agendamentos",
		      	auth: 		true,
		      	backButton: true,
		      	level: 		["admin", "profissional", "contratante"],
	      	},
	      	component: Agendamentos,
	      	beforeEnter: checkLogin,
	    },	
	    {
	      	path: '/teleconsulta/',
	      	name: 'Teleconsulta',
	      	meta: {
	      		title: 		"Teleconsulta",
		      	auth: 		true,
		      	backButton: true,
		      	level: 		["profissional", "contratante"],
	      	},
	      	component: Teleconsulta,
	      	beforeEnter: checkLogin,
	    },		    
	    {
	      	path: '/agenda/',
	      	name: 'Agenda',
	      	meta: {
	      		title: 		"Agenda",
		      	// auth: 		true,
		      	backButton: true,
		      	topClass: 	["transparent"],
		      	hideTitle: 	true,
		      	// level: 		["admin", "profissional", "contratante"],
	      	},
	      	component: Agenda,
	      	beforeEnter: checkLogin,
	    },		
	    {
	      	path: '/sintomas/',
	      	name: 'Sintomas',
	      	meta: {
	      		title: 		"Histórico de sintomas",
		      	auth: 		true,
		      	backButton: true,
		      	level: 		["admin", "profissional", "contratante"],
	      	},
	      	component: Sintomas,
	      	beforeEnter: checkLogin,
	    },			         	
	    {
	      	path: '/receitas/',
	      	name: 'Receitas',
	      	meta: {
	      		title: 		"Receitas e atestados",
		      	auth: 		true,
		      	backButton: true,
		      	level: 		["admin", "profissional", "contratante"],
	      	},
	      	component: Receitas,
	      	beforeEnter: checkLogin,
	    },	 		       
	    {
	      	path: '/profissionais/',
	      	name: 'Profissionais',
	      	meta: {
	      		title: 		"Novo agendamento",
		      	// auth: 		true,
		      	backButton: true,
		      	// level: 		["admin", "contratante"],
	      	},
	      	component: Profissionais,
	      	beforeEnter: checkLogin,
	    },
	    {
	      	path: '/mural/',
	      	name: 'Mural',
	      	meta: {
	      		title: 		"Mural",
		      	auth: 		true,
		      	backButton: true,
		      	level: 		["admin", "marketing"],
	      	},
	      	component: Mural,
	      	beforeEnter: checkLogin,
	    },
	    {
	      	path: '/campanhas/',
	      	name: 'Campanhas',
	      	meta: {
	      		title: 		"Campanhas",
		      	auth: 		true,
		      	backButton: true,
		      	level: 		["admin", "marketing"],
	      	},
	      	component: Campanhas,
	      	beforeEnter: checkLogin,
	    },	    	    	 	   	     
	    {
	      	path: '/exames/',
	      	name: 'Arquivos',
	      	meta: {
	      		title: 		"Meus exames",
		      	auth: 		true,
		      	backButton: true,
		      	level: 		["contratante"],
	      	},
	      	component: Arquivos,
	      	beforeEnter: checkLogin,
	    },	 
	    {
	      	path: '/configuracoes/',
	      	name: 'Configuracoes',
	      	meta: {
	      		title: 		"Configurações",
		      	auth: 		true,
		      	backButton: true,
		      	level: 		["admin"],
	      	},
	      	component: Configuracoes,
	      	beforeEnter: checkLogin,
	    },	 	    	       
	    {
	      	path: '/minha-conta/',
	      	name: 'Conta',
	      	meta: {
	      		title: 		"Minha conta",
		      	auth: 		true,
		      	backButton: true,
		      	level: 		["contratante", "admin", "profissional", "marketing"],
	      	},
	      	component: Conta,
	      	beforeEnter: checkLogin,
	    },
	    {
	      	path: '/alterar-senha/',
	      	name: 'AlterarSenha',
	      	meta: {
	      		title: 		"Alterar senha",
		      	auth: 		true,
		      	backButton: true,
		      	level: 		["contratante", "admin", "profissional", "marketing"],
	      	},
	      	component: AlterarSenha,
	      	beforeEnter: checkLogin,
	    },
	    {
	      	path: '/pacientes/',
	      	name: 'Pacientes',
	      	meta: {
	      		title: 		"Pacientes",
		      	auth: 		true,
		      	backButton: true,
		      	level: 		["admin", "profissional"],
		      	options: {
		      		"tipo": "contratante" 
		      	}
	      	},
	      	component: Pacientes,
	      	beforeEnter: checkLogin,
	    },
	    {
	      	path: '/emitir-receita',
	      	name: 'GerenciarReceitas',
	      	meta: {
	      		title: 		"Emitir receita eletrônica",
		      	auth: 		true,
		      	backButton: true,
		      	level: 		["profissional"],
		      	options: {
		      		
		      	}
	      	},
	      	component: GerenciarReceitas,
	      	beforeEnter: checkLogin,
	    },	
	    {
	      	path: '/pacientes/detalhes',
	      	name: 'Paciente',
	      	meta: {
	      		title: 		"Prontuário",
		      	auth: 		true,
		      	backButton: true,
		      	level: 		["profissional", "admin"],
		      	options: {
		      		
		      	}
	      	},
	      	component: Paciente,
	      	beforeEnter: checkLogin,
	    },		        
	    {
	      	path: '/usuarios/',
	      	name: 'UsuariosGeral',
	      	meta: {
	      		title: 		"Usuários",
		      	auth: 		true,
		      	backButton: true,
		      	level: 		["admin"],
		      	options: {
		      		"cadastrarBotaoTexto": 		"Cadastrar usuário",
		      		"cadastrarBotaoNome": 		"CadastrarUsuariosGeral",
		      		"editarBotaoNome": 			"EditarUsuariosGeral",
		      		"tipo": 					"admin,profissional,marketing" 
		      	}
	      	
	      	},
	      	component: Usuarios,
	      	beforeEnter: checkLogin,
	    },	    
	    {
	      	path: '/relatorios',
	      	name: 'Relatorios',
	      	meta: {
	      		title: 		"Relatórios",
		      	auth: 		true,
		      	backButton: true,
		      	level: 		["admin", "profissional"]
	      	},
	      	component: Relatorios,
	      	beforeEnter: checkLogin,
	    },		    	    
	    {
	      	path: '/usuarios/cadastro',
	      	name: 'CadastrarUsuariosGeral',
	      	meta: {
	      		title: 		"Cadastrar usuário",
		      	auth: 		true,
		      	backButton: true,
		      	level: 		["admin"]
	      	},
	      	component: GerenciarUsuarios,
	      	beforeEnter: checkLogin,
	    },	
	    {
	      	path: '/usuarios/editar',
	      	name: 'EditarUsuariosGeral',
	      	meta: {
	      		title: 		"Editar usuário",
		      	auth: 		true,
		      	backButton: true,
		      	level: 		["admin"]
	      	},
	      	component: GerenciarUsuarios,
	      	beforeEnter: checkLogin,
	    },	    		    	            
	    { path: '*', redirect: '/' }
  	]
})

const scrollPositions = Object.create(null)

_this.beforeEach((to, from, next) => {

  	let element = $(".dashboard-content-inner")[0];
  	if (element) {
	    scrollPositions[from.name] = element.scrollTop
  	}

  	next()
})

window.addEventListener('popstate', () => {
	setTimeout(function() {
	  	let currentRouteName = _this.history.current.name
	  	let element = $(".dashboard-content-inner")[0];
	  	if (element && scrollPositions[currentRouteName]) {
	    	element.scrollTop = scrollPositions[currentRouteName];
	    	scrollPositions[currentRouteName] = null;
	  	}
	}, 100);
})

export default _this;


// WEBPACK FOOTER //
// ./src/router/index.js